// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2yL7Z","sendOtp":"AuthorizeToLogin_sendOtp__1iDNL"};